/**
 * AccountSettingsSidebar - Sticky sidebar navigation for account settings
 * Design: Arc/Linear pattern with active state indicator
 */
import React from 'react';

const NAV_ITEMS = [
    { id: 'profile', icon: '👤', label: 'Profile' },
    { id: 'notifications', icon: '🔔', label: 'Notifications' },
    { id: 'appearance', icon: '🎨', label: 'Appearance' },
    { id: 'layouts', icon: '📐', label: 'Layouts' },
    { id: 'livezone', icon: '📡', label: 'Live Zone' },
    { id: 'for-you-section', icon: '⭐', label: 'For You' },
    { id: 'danger', icon: '⚠️', label: 'Danger Zone', danger: true },
];

export default function AccountSettingsSidebar({ activeSection, onNavigate }) {
    return (
        <aside className="settings-sidebar">
            <div className="settings-sidebar-card">
                <nav className="settings-nav">
                    {NAV_ITEMS.map((item) => (
                        <button
                            key={item.id}
                            className={`settings-nav-item ${activeSection === item.id ? 'active' : ''} ${item.danger ? 'danger' : ''}`}
                            onClick={() => onNavigate(item.id)}
                            aria-current={activeSection === item.id ? 'true' : undefined}
                        >
                            <span className="settings-nav-icon">{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </nav>
            </div>
        </aside>
    );
}
